import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { organizationDetailsUser } from "../../services/organizationService";

/* ================= THUNK ================= */

export const fetchCompanyDetails = createAsyncThunk(
  "companyDetails/fetch",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await organizationDetailsUser({ slug });

      if (res?.status === 200 && res?.data) {
        return res.data;
      }

      return rejectWithValue(res?.message || "Failed to fetch company");
    } catch (err) {
      return rejectWithValue(err?.message || "Something went wrong");
    }
  },
);

/* ================= INITIAL STATE ================= */

const initialState = {
  data: null,
  loading: false,
  error: null,
};

/* ================= SLICE ================= */

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {
    clearCompanyDetails: (state) => {
      state.data = null;
      state.error = null;
    },

    setCompanyDetails: (state, action) => {
      state.data = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })

      .addCase(fetchCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCompanyDetails, setCompanyDetails } =
  companyDetailsSlice.actions;

export default companyDetailsSlice.reducer;
